import { Button } from '@kcftech/design-system';
import { StatelessPopup } from 'components/popup/stateless_popup/StatelessPopup';
import { useKeyPress } from 'custom_hooks/useKeyPress';
import { IssueFaultType } from 'pages/Desk/issues/fault_type/useFaultTypes';
import { FaultTypesTree } from 'pages/Desk/issues/filter_pane/FaultTypesTree';
import { IssueMode } from 'pages/Desk/issues/shared';
import { Tree } from 'shared/data_tree/types';
import styled from 'styled-components';

const PopupContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    overflow: auto;
`;

const OuterPopupWrapper = styled.div`
    padding: 1rem;
    box-sizing: border-box;
    overflow: hidden;
    min-height: 0;
    display: flex;
    flex-direction: column;
`;

export type FaultTypeQuickFilterPopupProps = {
    close: () => void;
    maxHeight: string;
    selectedFaultTypeIds: string[];
    onChangeFaultTypeIds: (ids: string[]) => void;
    popupRef: React.RefObject<HTMLDivElement>;
    triggerRef: React.RefObject<HTMLButtonElement>;
    faultTypesTree: Tree<IssueFaultType>;
    issueMode: IssueMode;
};

export function FaultTypeQuickFilterPopup({
    close,
    maxHeight,
    selectedFaultTypeIds,
    onChangeFaultTypeIds,
    popupRef,
    triggerRef,
    faultTypesTree,
    issueMode,
}: FaultTypeQuickFilterPopupProps) {
    useKeyPress('Escape', () => {
        close();
    });

    return (
        <StatelessPopup
            ref={popupRef}
            onClose={close}
            anchor={triggerRef.current}
            collision={{
                horizontal: 'fit',
                vertical: 'none',
            }}
            noOverlay
            noPadding
        >
            <OuterPopupWrapper style={{ maxHeight }}>
                <Button
                    className="mb-5"
                    appearance="secondary"
                    spacing="compact"
                    disabled={selectedFaultTypeIds.length === 0}
                    onClick={() => onChangeFaultTypeIds([])}
                >
                    Clear
                </Button>
                <PopupContentWrapper>
                    <FaultTypesTree
                        issueMode={issueMode}
                        faultTypesTree={faultTypesTree}
                        selectedFaultTypeIds={selectedFaultTypeIds}
                        onSelectedChange={onChangeFaultTypeIds}
                    />
                </PopupContentWrapper>
            </OuterPopupWrapper>
        </StatelessPopup>
    );
}
